import { useEffect } from 'react';
import useMobxStores from './useMobxStores';

/**
 * Registers or unregisters a reason to hide the Pendo launcher based on a condition.
 * Use this in any component that should hide Pendo while active (e.g. AI assistant sidebar, modal).
 *
 * @param reasonId - Unique id for this hide reason (e.g. 'course:ai-assistant'). Must be stable.
 * @param shouldHide - When true, Pendo launcher is hidden; when false, this reason is cleared.
 */
export default function usePendoHideReason(
  reasonId: string,
  shouldHide: boolean,
): void {
  const { uiStore } = useMobxStores();

  useEffect(() => {
    if (shouldHide) {
      uiStore.registerPendoHideReason(reasonId);
    } else {
      uiStore.unregisterPendoHideReason(reasonId);
    }
    return () => {
      uiStore.unregisterPendoHideReason(reasonId);
    };
  }, [reasonId, shouldHide, uiStore]);
}
